import i18n from "i18next";
import Backend from "i18next-chained-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import LocalStorageBackend from "i18next-localstorage-backend"; // primary use cache
import { initReactI18next } from "react-i18next";
// import XHR from "i18next-xhr-backend"; // fallback xhr load
import HttpBackend from "i18next-http-backend";

i18n
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    whitelist: ["en-US", "ja-JP", "vi-VN"],
    fallbackLng: "en-US",
    debug: false,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: {
      backends: [
        HttpBackend, // primary
        LocalStorageBackend, // fallback
      ],
      backendOptions: [
        {
          /* below options */
          // prefix for stored languages
          prefix: "i18n_res_",

          // expiration
          expirationTime: 7 * 24 * 60 * 60 * 1000,

          // language versions
          versions: { "en-US": "v1.11", "ja-JP": "v1.11", "vi-VN": "v1.11" },

          // can be either window.localStorage or window.sessionStorage. Default: window.localStorage
          store: window.localStorage,
          loadPath: "/locales/v4/{{lng}}/{{ns}}.json", // xhr load path for my own fallback
        },
      ],
    },
    detection: {
      //LanguageDetector option
      // order and from where user language should be detected
      order: ["localStorage"],

      // keys or params to lookup language from
      lookupLocalStorage: "Lng",

      // cache user language on
      caches: ["localStorage"],
      //excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)

      // only detect languages that are in the whitelist
      checkWhitelist: true,
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
